import { render } from "./SpaceModal.vue?vue&type=template&id=785fdd3e"
import script from "./SpaceModal.vue?vue&type=script&lang=js"
export * from "./SpaceModal.vue?vue&type=script&lang=js"

import "./SpaceModal.vue?vue&type=style&index=0&id=785fdd3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__